import { Box, useClassNames } from '@factorialco/deprecated-design-system'

import * as stylesRefs from '../index.vanilla.css'
import CoverageSummary from './CoverageSummary'
import CoverageTitle from './CoverageTitle'

const Header = () => {
  const cx = useClassNames(stylesRefs)

  return (
    <Box
      background="grey100"
      width="full"
      height="s24"
      paddingY="s4"
      border={{
        top: { width: 's1', style: 'solid', color: 'grey300' },
        bottom: { width: 's1', style: 'solid', color: 'grey300' },
        right: { width: 's1', style: 'solid', color: 'grey300' },
      }}
      className={cx('header', 'sticky')}
    >
      <Box flexDirection="row" alignItems="center" width="full" height="full">
        <CoverageTitle />
        <CoverageSummary />
      </Box>
    </Box>
  )
}

export default Header
